import { selfAxios } from "../../../../../axios/selfAxios.js";
async function opPostGetProductionOrderBaseAttrLinkageRuleInfoByServiceId(params) {
  const res = await selfAxios.post(`/designordercenter/productionOrder/rule/getProductionOrderBaseAttrLinkageRuleInfoByServiceId`, params);
  return res.data;
}
export { opPostGetProductionOrderBaseAttrLinkageRuleInfoByServiceId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/productionOrder/rule/getProductionOrderBaseAttrLinkageRuleInfoByServiceId/post.js